import styled from 'styled-components'

export const RentContractFormWrap = styled.div`
  display: block;
  width: 100%;
  overflow: auto;

  .shadow-atom {
    padding-bottom: 0.5rem;
  }
`

export const PropertyHorizontalWrap = styled.div`
  margin-bottom: 1.5rem;
`;